import { render, staticRenderFns } from "./actions-list.vue?vue&type=template&id=55305524&"
import script from "./actions-list.vue?vue&type=script&lang=js&"
export * from "./actions-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports